export const default_file_accept_types = [
    "image/*",
    "application/pdf",
    "video/*",
];

export const default_file_uploaded_state = {
    uploadFile: "",
    url: "",
    thumbnail: "",
};
